import { Link } from "react-router-dom";
import { Phone, MessageCircle, CheckCircle, TrendingUp, Award, Shield } from "lucide-react";
import { useEffect } from "react";

const About = () => {
  const whatsappNumber = "905326369115";
  const phoneNumber = "05326369115";
  const whatsappMessage = encodeURIComponent(
    "Merhaba Dijital Mustafa, Google Ads reklamlarım hakkında bilgi almak istiyorum."
  );

  useEffect(() => {
    document.title = "Hakkımda - Dijital Mustafa | Google Ads Uzmanı";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "18 yıldır Google Ads dünyasında, Google Partner Ajans statüsüyle işletmeleri dijital pazarlama zirvesine taşıyorum."
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#012f23] via-[#024238] to-[#059669] py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Sol - Profil Resmi */}
            <div className="relative order-2 lg:order-1">
              {/* Glow Efekti */}
              <div className="absolute inset-0 bg-[#FFD700] rounded-full blur-3xl opacity-20 animate-pulse"></div>
              
              {/* Profil Resmi */}
              <div className="relative z-10 mx-auto w-80 h-80 md:w-96 md:h-96">
                <img 
                  src="/images/mustafa-kaya-profil.png" 
                  alt="Dijital Mustafa - Google Ads Uzmanı"
                  className="w-full h-full rounded-full object-cover border-8 border-white shadow-2xl"
                />
              </div>
              
              {/* Google Partner Badge */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 z-20">
                <img 
                  src="/images/google-partner-badge.png" 
                  alt="Google Partner Sertifikası"
                  className="h-20 md:h-24 w-auto drop-shadow-2xl"
                />
              </div>
            </div>

            {/* Sağ - Başlık & Açıklama */}
            <div className="text-white order-1 lg:order-2">
              <h1 className="text-5xl md:text-6xl font-black mb-6 leading-tight">
                Mustafa <span className="text-[#FFD700]">KAYA</span>
              </h1>
              <h2 className="text-3xl md:text-4xl font-bold text-[#25D366] mb-6">
                Google Ads Uzmanı
              </h2>
              <p className="text-xl md:text-2xl text-gray-200 leading-relaxed mb-8">
                <strong>18 yıldır</strong> Google Ads dünyasında, işletmeleri dijital pazarlama zirvesine taşıyorum. 
                <span className="text-[#FFD700] font-bold"> Google Partner Ajans</span> statümle, 
                her kampanyayı <strong>bizzat ben</strong> yönetiyorum.
              </p>
              
              {/* Hızlı İstatistikler */}
              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center border border-white/20 hover:bg-white/20 transition-all">
                  <p className="text-4xl md:text-5xl font-black text-[#FFD700]">18</p>
                  <p className="text-xs md:text-sm text-gray-300 mt-1">Yıl Deneyim</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center border border-white/20 hover:bg-white/20 transition-all">
                  <p className="text-4xl md:text-5xl font-black text-[#FFD700]">500+</p>
                  <p className="text-xs md:text-sm text-gray-300 mt-1">Başarılı Proje</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center border border-white/20 hover:bg-white/20 transition-all">
                  <p className="text-4xl md:text-5xl font-black text-[#FFD700]">5</p>
                  <p className="text-xs md:text-sm text-gray-300 mt-1">Aylık Kontenjan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hikayem - Timeline */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-16 text-gray-900">
            Benim <span className="text-[#059669]">Yolculuğum</span>
          </h2>
          
          <div className="relative">
            {/* Dikey çizgi */}
            <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-[#059669] via-[#FFD700] to-[#059669] hidden md:block"></div>
            
            {/* Timeline İtemleri */}
            <div className="space-y-12">
              {/* 2007 */}
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="w-full md:w-1/2 md:pr-12 text-left md:text-right mb-4 md:mb-0">
                  <h3 className="text-3xl font-bold text-[#059669] mb-2">2007</h3>
                  <p className="text-xl font-semibold text-gray-900 mb-2">İlk Adım 🚀</p>
                  <p className="text-gray-600 leading-relaxed">
                    Google AdWords (şimdiki adıyla Google Ads) dünyasına giriş yaptım. 
                    O günlerde "tıklama başına maliyet" kavramı bile yeniydi. İlk kampanyalarımı 
                    küçük yerel işletmeler için kurdum.
                  </p>
                </div>
                <div className="absolute left-1/2 -translate-x-1/2 w-12 h-12 bg-[#059669] rounded-full border-4 border-white shadow-lg flex items-center justify-center z-10 hidden md:flex">
                  <span className="text-2xl">🚀</span>
                </div>
                <div className="w-full md:w-1/2"></div>
              </div>

              {/* 2012 */}
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="w-full md:w-1/2 order-2 md:order-1"></div>
                <div className="absolute left-1/2 -translate-x-1/2 w-12 h-12 bg-[#059669] rounded-full border-4 border-white shadow-lg flex items-center justify-center z-10 hidden md:flex">
                  <span className="text-2xl">📈</span>
                </div>
                <div className="w-full md:w-1/2 md:pl-12 text-left mb-4 md:mb-0 order-1 md:order-2">
                  <h3 className="text-3xl font-bold text-[#059669] mb-2">2012</h3>
                  <p className="text-xl font-semibold text-gray-900 mb-2">100+ Başarılı Kampanya 📈</p>
                  <p className="text-gray-600 leading-relaxed">
                    Türkiye'nin dört bir yanından işletmelerle çalışmaya başladım. 
                    E-ticaret, hizmet sektörü, sağlık, eğitim... Her sektörden deneyim kazandım. 
                    Müşterilerim ortalama %280 ROI artışı elde etti.
                  </p>
                </div>
              </div>

              {/* 2018 */}
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="w-full md:w-1/2 md:pr-12 text-left md:text-right mb-4 md:mb-0">
                  <h3 className="text-3xl font-bold text-[#FFD700] mb-2">2018</h3>
                  <p className="text-xl font-semibold text-gray-900 mb-2">Google Partner Ajans 🏆</p>
                  <p className="text-gray-600 leading-relaxed">
                    Google'ın resmi partner ağına kabul edildim. Bu sertifika, uzmanlığımın 
                    Google tarafından onaylandığı anlamına geliyor. Aynı zamanda Google'dan 
                    doğrudan destek ve en güncel bilgilere erişim hakkı kazandım.
                  </p>
                </div>
                <div className="absolute left-1/2 -translate-x-1/2 w-12 h-12 bg-[#FFD700] rounded-full border-4 border-white shadow-lg flex items-center justify-center z-10 hidden md:flex">
                  <span className="text-2xl">🏆</span>
                </div>
                <div className="w-full md:w-1/2"></div>
              </div>

              {/* 2025 */}
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="w-full md:w-1/2 order-2 md:order-1"></div>
                <div className="absolute left-1/2 -translate-x-1/2 w-12 h-12 bg-[#FFD700] rounded-full border-4 border-white shadow-lg flex items-center justify-center z-10 hidden md:flex">
                  <span className="text-2xl">🎯</span>
                </div>
                <div className="w-full md:w-1/2 md:pl-12 text-left mb-4 md:mb-0 order-1 md:order-2">
                  <h3 className="text-3xl font-bold text-[#FFD700] mb-2">2025</h3>
                  <p className="text-xl font-semibold text-gray-900 mb-2">Bugün 🎯</p>
                  <p className="text-gray-600 leading-relaxed">
                    500+ başarılı projeyle işletmelere kişisel hizmet sunuyorum. 
                    Her kampanyayı bizzat ben yönetiyorum - bu yüzden ayda sadece 5 yeni firma alıyorum. 
                    Kaliteden ödün vermiyorum.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Neden Benimle Çalışmalısınız */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-4 text-gray-900">
            Neden <span className="text-[#059669]">Beni</span> Seçmelisiniz?
          </h2>
          <p className="text-center text-gray-600 text-lg mb-12 max-w-3xl mx-auto">
            18 yıllık deneyimimle, sadece reklam yönetimi değil, işinize özel strateji sunuyorum.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            
            <div className="bg-gradient-to-br from-[#059669] to-[#047857] rounded-2xl p-8 text-white transform hover:scale-105 transition-transform shadow-xl">
              <div className="text-5xl mb-4">🎯</div>
              <h3 className="text-2xl font-bold mb-3">Kişisel Yönetim</h3>
              <p className="text-gray-100 leading-relaxed">
                Ekip yok, outsourcing yok. Her kampanyayı <strong>bizzat ben</strong> kuruyorum, 
                yönetiyorum ve optimize ediyorum. Sizinle direkt iletişim, her zaman.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-2xl p-8 text-gray-900 transform hover:scale-105 transition-transform shadow-xl">
              <div className="text-5xl mb-4">🏆</div>
              <h3 className="text-2xl font-bold mb-3">Google Partner</h3>
              <p className="text-gray-800 leading-relaxed">
                Google'ın resmi partner ağı üyesiyim. Bu, en güncel bilgiye erişimim 
                ve Google'dan doğrudan destek alabilirim demek.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-8 text-white transform hover:scale-105 transition-transform shadow-xl">
              <div className="text-5xl mb-4">🛡️</div>
              <h3 className="text-2xl font-bold mb-3">Sahte Tıklama Koruması</h3>
              <p className="text-gray-100 leading-relaxed">
                Bütçenizi çalan sahte tıklamaları <strong>%80 oranında</strong> engelleyen 
                özel yazılım kullanıyorum. Paranız gerçek müşterilere harcanıyor.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl p-8 text-white transform hover:scale-105 transition-transform shadow-xl">
              <div className="text-5xl mb-4">📊</div>
              <h3 className="text-2xl font-bold mb-3">Şeffaf Raporlama</h3>
              <p className="text-gray-100 leading-relaxed">
                Her hafta detaylı performans raporları. Paranızın nereye gittiğini, 
                hangi kampanyaların işe yaradığını <strong>şeffaf bir şekilde</strong> görürsünüz.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-500 to-orange-500 rounded-2xl p-8 text-white transform hover:scale-105 transition-transform shadow-xl">
              <div className="text-5xl mb-4">⚡</div>
              <h3 className="text-2xl font-bold mb-3">Sürekli Optimizasyon</h3>
              <p className="text-gray-100 leading-relaxed">
                Google Ads "kur unut" değildir. <strong>Her gün</strong> kampanyalarınızı 
                kontrol ediyor, testler yapıyor ve iyileştiriyorum.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-500 to-teal-500 rounded-2xl p-8 text-white transform hover:scale-105 transition-transform shadow-xl">
              <div className="text-5xl mb-4">💼</div>
              <h3 className="text-2xl font-bold mb-3">Sınırlı Kontenjan</h3>
              <p className="text-gray-100 leading-relaxed">
                Kaliteden ödün vermemek için <strong>ayda sadece 5 yeni firma</strong> 
                alıyorum. Her projeye hak ettiği özeni gösteriyorum.
              </p>
            </div>
          </div>
        </div>
      </section>

      

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-[#012f23] via-[#024238] to-[#059669]">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-white leading-tight">
            Hazır mısınız? <span className="text-[#FFD700]">Hemen Başlayalım!</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            <span className="text-[#FFD700] font-bold">15 dakikalık ücretsiz görüşme</span> 
            ile kampanyalarınızı analiz edip size özel strateji sunuyorum.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a
              href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white rounded-xl font-bold text-lg hover:bg-[#20BA5A] transition-colors shadow-2xl hover:scale-105 transform"
            >
              <MessageCircle className="w-6 h-6" />
              WhatsApp ile İletişime Geç
            </a>
            <a
              href={`tel:${phoneNumber}`}
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 text-white rounded-xl font-bold text-lg hover:bg-white/20 transition-colors border-2 border-white/30 hover:scale-105 transform"
            >
              <Phone className="w-6 h-6" />
              Hemen Ara
            </a>
          </div>

          <div className="bg-[#FFD700]/20 rounded-xl p-4 border border-[#FFD700]/50 max-w-2xl mx-auto">
            <p className="text-sm md:text-base text-white font-semibold flex items-center justify-center gap-2">
              <span>⚠️</span>
              <span>Ayda sadece 5 yeni firma alıyorum. Kontenjan dolmadan başvurun!</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

